import { Injectable } from '@angular/core';
import { ICountry } from 'app/models/country.model';
import * as isoCountries from 'i18n-iso-countries';
import * as moment from 'moment-timezone';

declare let require: any;
isoCountries.registerLocale(require('i18n-iso-countries/langs/en.json'));

@Injectable({
  providedIn: 'root'
})
export class CountryService {

  readonly LANG: string = 'en';
  private countries: ICountry[] = new Array();

  findAll = (): ICountry[] => {
    const rawCountries = isoCountries.getNames(this.LANG);
    // eslint-disable-next-line guard-for-in
    for (const key in rawCountries) {
      const value = rawCountries[key];
      const item = { id: key, name: value };
      this.countries.push(item);
    }
    return this.countries;
  };

  findTmzForCountry(countryId: string): any {
    const found = moment.tz.zonesForCountry(countryId, true);
    return found;
   }

}
